import { render } from "./Navbar4.vue?vue&type=template&id=2d381d62"
import script from "./Navbar4.vue?vue&type=script&lang=js"
export * from "./Navbar4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__